import React, { useEffect, useState } from 'react';
import { useRouter } from 'next/router';

import { webSearchPath, webSearchTitle } from 'components/search/web-search-registry';
import { useStorage, useStore } from 'contexts';

export const SearchContext = React.createContext(null);

const SearchProvider = ({ children }) => {
	const [facets, setFacets] = useState<any>({});
	const [sidebar, setSidebar] = useState(false);
	const [slide, setSlide] = useState(false);
	const router = useRouter();
	const storage = useStorage();
	const store = useStore();

	// Hooks
	useEffect(() => {
		setSlide(false);
	}, [router.asPath]);

	// Actions
	const onSave = (modelName, query, result) => {
		try {
			const modelId = result?.id;
			const formattedQuery = query.toLowerCase();
			const search = storage.getValue('search') || [];
			const formattedSearch = search
				.slice(0, 10)
				.filter(hit => hit.modelName !== modelName || hit.query !== formattedQuery);
			const formattedRecord = { modelId, modelName, query: formattedQuery, result, date: new Date() };
			storage.storeValue('search', formattedSearch.concat(formattedRecord));
			if (result.searchScope !== 'workspace')
				store.saveRecord({ url: '/searches', data: { modelId, modelName, query: formattedQuery, result } });
		} catch (e) {
			console.error(e);
		}
	};

	const onClick = result => {
		onSave(result.index, webSearchTitle(result), result);
		return router.push(webSearchPath(result));
	};

	// Methods
	const onClear = (props = []) => {
		router.push(window.location.pathname);
	};

	const onToggle = () => setSidebar(!sidebar);

	const onFilter = filters => {
		const params = new URLSearchParams(window.location.search);
		Object.keys(filters).map(key => {
			if (filters[key] !== '' && filters[key] !== null && filters[key] !== undefined) {
				return params.set(key, filters[key]);
			}
			params.delete(key);
		});
		router.push(window.location.pathname + '?' + params.toString(), undefined, { shallow: true });
	};

	// Render
	return (
		<SearchContext.Provider
			value={{
				facets,
				setFacets,
				sidebar,
				setSidebar,
				slide,
				setSlide,
				onSave,
				onClick,
				onClear,
				onToggle,
				onFilter,
			}}>
			{children}
		</SearchContext.Provider>
	);
};

const useSearch = () => {
	return React.useContext(SearchContext);
};

export { SearchProvider, useSearch };

// We could switch render depending on route.
